import { preferences } from '@wix/wix-data-client-common/dist/esm/createOrEditCollectionPanel'
import type {
  DataSettingsManager,
  Logger,
  SafeUserPreferences,
} from '@wix/wix-data-client-common-standalone'
import { enableDataMode, isDataModeEnabled } from '@wix/wix-data-client-common'

export const ensureDataModeIsEnabled = async ({
  dataSettingsManager,
  safeUserPreferences,
  logger,
}: {
  dataSettingsManager: DataSettingsManager
  safeUserPreferences: SafeUserPreferences
  logger: Logger
}) => {
  const dataModeEnabled = isDataModeEnabled(dataSettingsManager)

  if (!dataModeEnabled) {
    await enableDataMode({ logger, dataSettingsManager })

    safeUserPreferences.set({
      [preferences.INTRO_WAS_SHOWN]: true,
    })
  }

  return { enableDataModeTriggered: !dataModeEnabled }
}
